import FeaturePage from "../../components/FeaturePage";
import { Users, Building2, BarChart3, Workflow, Lock, Headphones } from "lucide-react";

export default function Medium() {
  return (
    <FeaturePage
      badge="For Medium Businesses"
      title="Scale without the chaos."
      highlight=""
      subtitle="You've outgrown spreadsheets and Frankenstein integrations. Brivo gives you multi-staff, multi-location, multi-warehouse — one calm dashboard."
      heroImage="https://images.unsplash.com/photo-1763718528755-4bca23f82ac3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
      heroBg="cream"
      features={[
        { icon: <Users size={22} />, title: "Team workflows", desc: "Roles, approvals, and audit logs designed for growing teams." },
        { icon: <Building2 size={22} />, title: "Multi-location", desc: "Run unlimited stores or warehouses with one Brivo account." },
        { icon: <BarChart3 size={22} />, title: "Advanced analytics", desc: "Cohort analysis, profit margin reports, custom dashboards." },
        { icon: <Workflow size={22} />, title: "Automations", desc: "Eliminate the manual 'glue work' with workflow automation." },
        { icon: <Lock size={22} />, title: "Granular permissions", desc: "Show each role exactly what they need — nothing more." },
        { icon: <Headphones size={22} />, title: "Priority support", desc: "Email + chat support with sub-2hr first-response SLA." },
      ]}
      details={[
        {
          tag: "Operations",
          title: "From 5 employees to 500. No re-platforming.",
          desc: "Brivo grows with you. Add staff, add locations, add channels — all without migrating data, breaking integrations, or paying setup fees.",
          bullets: ["Add unlimited staff and roles", "Roll out new locations in hours", "No data migrations needed"],
        },
        {
          tag: "Reporting",
          title: "Reports that actually answer 'why'.",
          desc: "Stop staring at spreadsheets. Brivo's analytics layer surfaces the insights you'd hire a $200k analyst to find — automatically.",
        },
      ]}
      useCases={[
        { title: "Multi-store retail", desc: "10–50 locations with central HQ visibility." },
        { title: "DTC brands", desc: "Scale from launch to 8-figures." },
        { title: "B2B distributors", desc: "Wholesale with NET terms and quotas." },
        { title: "F&B chains", desc: "Recipe costing, multi-outlet POS." },
      ]}
      ctaTitle="Built for the messy middle."
      ctaSubtitle="Brivo gives growing businesses the tools they thought only enterprise had."
      ctaAccent="mint"
    />
  );
}
